import * as angular from 'angular';

import { DatabaseSelector } from './select-db-connect-component';

class SelectorListController {
  private dbList: DatabaseSelector[];
  private flowFromParams: string;

  static $inject = [];
  constructor() {}
}

const SelectorListComponent: angular.IComponentOptions = {
  controller: SelectorListController,
  controllerAs: 'ctrl',
  bindings: {
    dbList: '<',
    flowFromParams: '<',
  },
  template: `
    <div class="individual-selector-list-container">
      <selector-item
        ng-repeat="individualDb in ctrl.dbList"
        selector-info="individualDb"
        class="selector-item"
        flow-from-params="ctrl.flowFromParams"
      ></selector-item>
    </div>`,
};

angular.module('mode.components').component('selectorList', SelectorListComponent);
